---
title: Separating service lines from product lines
slug: service-lines-and-product-lines
type: thinking-note
status: published
featured: true
summary: A service line sells effort. A product line sells a stable core with variability at the edges. Mixing the two is how platforms quietly become consultancies.
sitePublishedAt: "2026-09-18"
lastReviewedAt: "2026-09-18"
audiences:
  - business
themes:
  - product-lines
  - platform-architecture
originalAuthor: Jay van Zyl
sourceRelationship: first-party thinking note restating a long-running essay theme
rightsStatus: first-party
seoDescription: Jay van Zyl on why product lines and service lines must stay distinct if a platform is going to exist.
canonicalPath: /thinking/service-lines-and-product-lines
---

A service line is a way of selling skilled effort. It can be excellent. It does not accumulate. When the people leave, the capability leaves.

A product line is a way of selling a stable core with declared variation. Commonality lives in the platform. Differences are configuration, composition, and policy — not a fork, and not a clever `if (client === …)` in the runtime.

I have been writing this since the early product-line papers. EcosystemCode is the same idea made executable: validate the model, generate the baseline, bind product differences outside the core. ecosystem.Ai is the same idea on the prediction side: algorithms and a pulse responder as common capability, campaigns and offers as variability.

If your “platform” needs a project team to exist for every new tenant, you are running a service line with a product vocabulary. That is not a moral failure. It is a classification. Classify it correctly before you promise scale.
